<template>
	<v-layout row wrap fill-height class="team">
		<v-flex xs12 md3>
			<infinite-scroll
				element-type="v-card"
				:has-more-pages="hasMorePages"
				@bottom="loadMore"
			>
				<v-list class="py-0 admin__sidebar-menu" dark>
					<v-list-tile
						ripple
						to="/admin/users/create"
						avatar
						class="secondary"
					>
						<v-list-tile-avatar>
							<div class="v-icon secondary theme--dark">
								<fa-icon :icon="['far', 'user']" size="xs" />
							</div>
						</v-list-tile-avatar>

						<v-list-tile-content>
							<v-list-tile-title>Add User</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>

					<v-list-tile
						ripple
						to="/admin/users/import"
						avatar
						class="secondary"
					>
						<v-list-tile-avatar>
							<div class="v-icon secondary theme--dark">
								<fa-icon :icon="['far', 'user']" size="xs" />
							</div>
						</v-list-tile-avatar>

						<v-list-tile-content>
							<v-list-tile-title>Import Users</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
				</v-list>

				<v-list
					class="py-0 admin__sidebar-menu"
					v-if="$vuetify.breakpoint.mdAndUp"
				>
					<v-list-tile
						ripple
						avatar
						v-for="user in filteredUsers"
						:key="user.id"
						:to="`/admin/users/${user.id}`"
					>
						<v-list-tile-avatar style="font-size: 0">
							<img :src="user.photo_url" :alt="user.name" />
						</v-list-tile-avatar>

						<v-list-tile-content>
							<span v-html="userName(user)"></span>
						</v-list-tile-content>
					</v-list-tile>
				</v-list>

				<v-list v-else class="py-0">
					<v-list-group
						:value="listOpen"
						@click="listOpen = !listOpen"
					>
						<v-list-tile
							slot="activator"
							class="decision-tree__category"
						>
							<v-list-tile-content>
								<v-list-tile-title>All Users</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>

						<infinite-scroll
							element-type="div"
							:has-more-pages="hasMorePages"
							@bottom="loadMore"
							style="overflow: auto; max-height: 300px;"
						>
							<v-list-tile
								ripple
								avatar
								v-for="user in filteredUsers"
								:key="user.id"
								@click="listOpen = false"
								:to="`/admin/users/${user.id}`"
							>
								<v-list-tile-avatar style="font-size: 0">
									<img
										:src="user.photo_url"
										:alt="user.name"
									/>
								</v-list-tile-avatar>

								<v-list-tile-content>
									<span v-html="userName(user)"></span>
								</v-list-tile-content>
							</v-list-tile>
						</infinite-scroll>
					</v-list-group>
				</v-list>
			</infinite-scroll>
		</v-flex>

		<v-flex xs12 md9 v-if="$route.fullPath.indexOf('/users/') >= 0">
			<router-view :key="$route.fullPath"></router-view>
		</v-flex>
	</v-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import InfiniteScroll from "../../partials/InfiniteScroll";

export default {
	data() {
		return {
			showAddUserForm: false,
			listOpen: false
		};
	},

	components: {
		InfiniteScroll
	},

	props: {
		id: {
			default: null
		}
	},

	computed: {
		...mapGetters("admin", {
			USERS: "users",
			LAST_PAGE: "usersLastPage",
			PAGE: "usersPage"
		}),

		...mapGetters(["searchQuery"]),

		searchRegex() {
			return (flags = "gi") => new RegExp(this.searchQuery, flags);
		},

		hasMorePages() {
			return this.PAGE < this.LAST_PAGE;
		},

		filteredUsers() {
			let users = this.USERS;

			if (this.searchQuery) {
				let sq = this.searchQuery.toLowerCase();

				users = _.filter(users, user => {
					return (
						this.getObjectValue("name", user, "")
							.toLowerCase()
							.indexOf(sq) >= 0
					);
				});
			}

			return _.orderBy(users, [user => user.name.toLowerCase()]);
		}
	},

	methods: {
		...mapActions({
			GET_USERS: "getUsers"
		}),

		...mapActions("admin", ["getPermissionGroups"]),

		addUser() {
			this.showAddUserForm = true;
		},

		loadMore() {
			if (this.hasMorePages) {
				this.getUsers(this.PAGE + 1);
			}
		},

		getUsers: _.debounce(function(page = 1) {
			this.GET_USERS({ admin: true, page });
		}, 400),

		userName(user) {
			const userName = user.name;

			if (this.searchQuery) {
				return this.highlight(userName);
			}

			return userName;
		},

		highlight(text, flags) {
			return (text = text.replace(this.searchRegex(flags), found => {
				return `<span class="search-highlight">${found}</span>`;
			}));
		}
	},

	created() {
		this.getPermissionGroups();

		this.GET_USERS({ admin: true, page: 1 }).then(() => {
			this.$nextTick(() => {
				this.loadMore();
			});
		});
	},

	watch: {
		searchQuery(value, oldValue) {
			this.getUsers(value !== oldValue ? 1 : this.PAGE);
		}
	}
};
</script>
